<template>
    <div>
        <div class="chart-box" id="first"></div>
        <div class="chart-box" v-if="false" id="second"></div>
        <div class="chart-box" v-if="false" id="third"></div>
        <div class="chart-box" v-if="false" id="fourth"></div>
    </div>
</template>

<script>
import { foldChart } from '../echarts';
import { GetOpenCourseCurveData } from '@/api/courseDetailStatistics';
    export default {
        data(){
            return{
                myChart:null
            }
        },
        props:{
            id:{
                default:''
            }
        },
        methods:{
            /**获取开课数据统计曲线图 */
            getOpenCourseCurveData(){
                var params={
                    courseId:this.courseId,
                    openCourseId:this.detail.openCourseId
                }
                GetOpenCourseCurveData(params).then(res=>{
                    if(res.code==200){
                        var obj={
                            "averageStudyTime": {
                                label:'人均学习时长',
                                data:[]
                            },
                            "studyCount": {
                                label:'学习人数',
                                data:[]
                            },
                            "studyNumberCount": {
                                label:'学习人次',
                                data:[]
                            },
                            "totalStudyTime": {
                                label:'总学习时长',
                                data:[]
                            },
                        };
                        var week=[];
                        res.data.forEach(item=>{
                            obj.averageStudyTime.data.push(item.averageStudyTime);
                            obj.studyCount.data.push(item.studyCount);
                            obj.studyNumberCount.data.push(item.studyNumberCount);
                            obj.totalStudyTime.data.push(item.totalStudyTime);
                            week.push(item.week);
                        })
                        this.myChart=foldChart('first','开课情况统计',obj,week);
                    }
                })
            },
            /**在线问答统计 */
            onlineChart(){
                var obj={
                            "a": {
                                label:'参与问答人数',
                                data:[]
                            },
                            "b": {
                                label:'参与问答次数',
                                data:[]
                            },
                            "c": {
                                label:'回答正确率',
                                data:[]
                            },
                        };
                    foldChart('second','在线问答统计',obj);
            },
            /**单元测试统计 */
            unitTest(){
                var obj={
                            "a": {
                                label:'参与测试人数',
                                data:[]
                            },
                            "b": {
                                label:'参与测试次数',
                                data:[]
                            },
                            "c": {
                                label:'测试合格率',
                                data:[]
                            },
                        };
                    foldChart('third','单元测试统计',obj);
            },
            /**课程考试统计 */
            courseExamine(){
                var obj={
                            "a": {
                                label:'参与考试人数',
                                data:[]
                            },
                            "b": {
                                label:'参与考试次数',
                                data:[]
                            },
                            "c": {
                                label:'考试合格率',
                                data:[]
                            },
                        };
                    foldChart('fourth','课程考试统计',obj);
            },
            /**重置图表 */
            resizeChart(){
                this.myChart&&this.myChart.resize();
            }
        },
        computed:{
            detail(){
                return this.$store.state.course.courseDetailData.detail;
            },
            courseId(){
                return this.$route.query.id||this.id;
            },
            showSlider(){
                return this.$store.state.media.showSlider;
            },
        },
        watch:{
            showSlider(){
                this.myChart&&this.myChart.dispose();
                this.getOpenCourseCurveData();
            }
        },
        mounted(){
            window.addEventListener('resize',this.resizeChart);
            this.getOpenCourseCurveData();
            // this.onlineChart();
            // this.unitTest();
            // this.courseExamine();
        },
        destroyed(){
            window.removeEventListener('resize',this.resizeChart);
        }
    }
</script>

<style lang="less" scoped>
.chart-box{
    height: 38rem;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    box-shadow: 0px 0px 15px 0px rgba(231,236,239,0.10); 
    margin-top: 3rem;
    padding: 2rem;
    }
@media screen and (max-width: 750px) {
    .chart-box{
        height: 45rem;
    }
}
</style>